import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Message from './message/message.component';
import Spinner from '../../components/reusable/spinner/spinner.component';

import Client from '../../tools/client';
import { ensureSocketConnected, onSafe } from '../../tools/socket';

import {
  MainContainer,
  MessagesTable,
  MessagesTableHeader,
  MessagesTableHead,
  MessagesTableBody,
  MessagesTableRow,
  MessagesTitle,
  TabContainer,
  TabSelector
} from './messages.styles';

const client = new Client();

const buildFilters = (tab) => {
  switch (tab) {
    case 'pending':
      return { status: 'pending', deleted: false };
    case 'read':
      return { status: 'read', deleted: false };
    case 'deleted':
      return { deleted: true };
    default:
      return { deleted: false };
  }
};

const MessagesPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentTab, setCurrentTab] = useState('pending');
  const [messages, setMessages] = useState([]);

  const fetchMessages = async (tab = currentTab) => {
    setLoading(true);
    try {
      const filters = buildFilters(tab);
      const res = await client.getMessages(filters);
      setMessages(res);
    } catch (err) {
      console.error('Failed to fetch messages:', err);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ensureSocketConnected();
    const offNewMessage = onSafe('newMessage', () => fetchMessages('pending'));
    return () => offNewMessage();
  }, []);

  useEffect(() => {
    fetchMessages();
  }, [currentTab]);

  return loading ? (
    <Spinner />
  ) : (
    <MainContainer>
      <TabContainer>
        {['pending', 'read', 'all', 'deleted'].map((tabKey) => (
          <TabSelector
            key={tabKey}
            active={currentTab === tabKey}
            onClick={() => setCurrentTab(tabKey)}
          >
            {tabKey === 'pending'
              ? 'New'
              : tabKey === 'read'
              ? 'Read'
              : tabKey === 'all'
              ? 'Active'
              : 'Deleted'}
          </TabSelector>
        ))}
      </TabContainer>

      <MessagesTitle>Messages</MessagesTitle>

      <MessagesTable>
        <MessagesTableHeader>
          <MessagesTableRow>
            <MessagesTableHead>Status</MessagesTableHead>
            <MessagesTableHead>Replied</MessagesTableHead>
            <MessagesTableHead>Name</MessagesTableHead>
            <MessagesTableHead>Date</MessagesTableHead>
          </MessagesTableRow>
        </MessagesTableHeader>

        <MessagesTableBody>
          {messages.map((message) => (
            <MessagesTableRow
              key={message.id}
              onClick={() => navigate(`/messages/${message.id}`)}
            >
              <Message message={message} />
            </MessagesTableRow>
          ))}
        </MessagesTableBody>
      </MessagesTable>
    </MainContainer>
  );
};

export default MessagesPage;